export const fetchCommentsClientTranslations = (httpClient, language) => httpClient.get(`/_serverless/comments-web-translations-proxy/comments-ooi/${language}`);
//# sourceMappingURL=index.js.map